import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { UI_CONFIG } from '../ui.config';
import { UiConfig } from '../ui.interface';

@Component({
  selector: 'fl-flag',
  template: `
    <img class="FlagImage"
      [src]="imagePath"
      (error)="onImageFetchError()"
      role="presentation"
    />
  `,
  styleUrls: ['./flag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlagComponent implements OnChanges {
  private forceUnknown = false;

  imagePath = '';

  @Input() country = 'unknown';

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(UI_CONFIG) private uiConfig: UiConfig,
  ) {}

  onImageFetchError() {
    if (!this.forceUnknown) {
      // Well this sucks. Show the unknown flag for now.
      this.forceUnknown = true;
      this.imagePath = this.getFlagImage();
      this.changeDetectorRef.markForCheck();
    }
  }

  private getFlagImage() {
    if (this.forceUnknown || this.country === undefined) {
      return `${this.uiConfig.assetsBaseUrl}/flags/unknown.svg`;
    }
    return `${this.uiConfig.assetsBaseUrl}/flags/${this.country}.svg`;
  }

  ngOnChanges(changes: SimpleChanges) {
    const properties = Object.keys(changes);
    if (properties.includes('country')) {
      // There's a possibility that the new `country` can be a country with an existing flag. Flip
      // forceUnknown to false to check.
      this.forceUnknown = false;
      this.imagePath = this.getFlagImage();
    }
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/ui/flag/flag.component.ts